import { ENUM_TYPE_VIDEO } from 'constants/enum';
import SampleVideoList from 'pages/SampleVideo/List/SampleVideo';

const SampleVideoDAY = () => {
  return <SampleVideoList type={ENUM_TYPE_VIDEO.DAY} />;
};

export default SampleVideoDAY;
